// src/pages/TalleresCrear/components/Paso5Confirmacion.jsx
import React from 'react';
import { Result, Button, Card, Space, Tag } from 'antd';
import { CheckCircleOutlined, EyeOutlined, PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

export default function Paso5Confirmacion({ tallerId, nombreTaller, cantidadHorarios }) {
  const navigate = useNavigate();

  return (
    <Card>
      <Result
        status="success"
        title="¡Taller creado exitosamente!"
        subTitle={
          <Space direction="vertical" size="middle" className="text-center">
            <div>
              El taller <strong>{nombreTaller}</strong> ha sido creado correctamente.
            </div>
            {cantidadHorarios > 0 && (
              <Tag color="blue" className="text-base px-4 py-1">
                {cantidadHorarios} {cantidadHorarios === 1 ? 'horario' : 'horarios'} agregado(s)
              </Tag>
            )}
          </Space>
        }
        icon={<CheckCircleOutlined />}
        extra={[
          <Button
            key="ver"
            type="primary"
            size="large"
            icon={<EyeOutlined />}
            onClick={() => navigate(`/admin/talleres/editar/${tallerId}`)}
          >
            Ver taller
          </Button>,
          <Button
            key="nuevo"
            size="large"
            icon={<PlusOutlined />}
            onClick={() => window.location.reload()}
          >
            Crear otro taller
          </Button>,
          <Button
            key="lista"
            size="large"
            onClick={() => navigate('/admin/talleres/lista')}
          >
            Ir a lista de talleres
          </Button>
        ]}
      />
    </Card>
  );
}
